import React, { useState, createElement, useEffect } from 'react'
import ReactDom from 'react-dom'
import { Button, Modal, Form, Radio } from 'tea-component';
import './index.scss'
enum timeScaleOptions {
  _5MIN = '5',
  _10MIN = '10',
  _60MIN = '60'
}
const { _5MIN, _10MIN, _60MIN } = timeScaleOptions;
interface DownloadOptions {
  title : string,
  visible?: boolean,
  options: {
    timeScale: [
      {
        name : string,
        label : string,
        disabled? : boolean | false
      }
    ]
    sort?: 0 | 1,
    default: string,
    sorting?: boolean
  }
  onConfirm?: (formValue) => void,
  onExited?: () => void;
  formatMessage?: (val: any) => string
}
const DownloadOptionsModalCo = (props: DownloadOptions) => {
  const { onConfirm, onExited, options, visible, title } = props;
  // const { formatMessage } = useIntl();
  const formatMessage = props.formatMessage || function (val) {
    return val.id
  };
  const [showModal, setShowModal] = useState(visible || false);
  const [formValue, setFormValue] = useState<any>({
    timeScale: options.default || _5MIN,
    sort: options?.sort || 0,
  });

  useEffect(()=>{
    if(visible){
      setShowModal(visible);
    }
  },[visible])

  return <Modal
    visible={showModal}
    className={'download_setting_modal'}
    caption={formatMessage({ id: 'realtime_info_download_settings' })}
    onClose={() => setShowModal(false)}
    onExited={() => onExited && onExited()}
    maskClosable
  >
    <Modal.Body>
      <Form
        className={'download_setting_form'}
      >
        <Form.Item
          label={<span className='download-text'>{ title }</span>}
          className={'download_setting_form_item'}
        >
          <Radio.Group
            value={formValue.timeScale}
            onChange={(val => 
              setFormValue({ ...formValue, timeScale: val })
            )}>
            {
              options?.timeScale?.map((val)=>{
                return (
                  <Radio name={val.name} disabled={val.disabled} key={val.name}>
                    {val.label}
                  </Radio>
                )
              })
            }
          </Radio.Group>
        </Form.Item>
        {props.options.sorting &&
          <Form.Item
            label={<span className='download-text'>{title}</span>}
            className={'download_setting_form_item'}
          >
            <Radio.Group
              value={'' + formValue.sort}
              onChange={(val => setFormValue({ ...formValue, sort: parseInt(val) }))}>
              <Radio name={'1'}>
                {formatMessage({ id: 'realtime_info_download_sort_up' })}
              </Radio>
              <Radio name={'0'}>
                {formatMessage({ id: 'realtime_info_download_sort_down' })}
              </Radio>
            </Radio.Group>
          </Form.Item>
        }
      </Form>
    </Modal.Body>
    <Modal.Footer>
      <Button type="primary" onClick={() => { onConfirm && onConfirm(formValue); setShowModal(false); }}>
        {formatMessage({ id: 'menu_confirm' })}
      </Button>
      <Button type="weak" onClick={() => setShowModal(false)}>
        {formatMessage({ id: 'menu_cancel' })}
      </Button>
    </Modal.Footer>
  </Modal>
}

export default DownloadOptionsModalCo;
